import { styled } from '@mui/material'

const curve = 'cubic-bezier(0.650, 0.000, 0.450, 1.000)'

interface StyledSvgProps {
  color?: string
}

const StyledSvg = styled('svg')<StyledSvgProps>(({ theme, color }) => ({
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  display: 'block',
  strokeWidth: 2,
  stroke: theme.palette.common.white,
  strokeMiterlimit: 10,
  animation:
    'fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both',
  '@keyframes fill': {
    '100%': {
      boxShadow: `inset 0px 0px 0px 30px ${color || theme.palette.error.main}`,
    },
  },
  '@keyframes scale': {
    '0%, 100%': {
      transform: 'none',
    },
    '50%': {
      transform: 'scale3d(1.1, 1.1, 1)',
    },
  },
}))

const Circle = styled('circle')<StyledSvgProps>(({ theme, color }) => ({
  strokeDasharray: '166',
  strokeDashoffset: '166',
  strokeWidth: 2,
  strokeMiterlimit: 10,
  stroke: color || theme.palette.error.main,
  fill: 'none',
  animation: `stroke 0.6s ${curve} forwards`,
  '@keyframes stroke': {
    '100%': {
      strokeDashoffset: '0',
    },
  },
}))

// Criando dois paths para formar o X
const XLine = styled('path')<StyledSvgProps>(() => ({
  transformOrigin: '50% 50%',
  strokeDasharray: '40',
  strokeDashoffset: '40',
  strokeWidth: 2,
  animation: `stroke 0.3s ${curve} 0.8s forwards`,
}))

interface AnimatedXMarkProps {
  color?: string
}

export const AnimatedXMark = ({ color }: AnimatedXMarkProps) => (
  <StyledSvg
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <Circle
      className="xmark__circle"
      cx="26"
      cy="26"
      r="25"
      fill="none"
      color={color}
    />
    <XLine
      className="xmark__line1"
      fill="none"
      d="M17 17L35 35"
      color={color}
    />
    <XLine
      className="xmark__line2"
      fill="none"
      d="M35 17L17 35"
      color={color}
    />
  </StyledSvg>
)
